import Level from './Level';
import { Button } from 'react-bulma-components';
import {
    Link, NavLink
  } from "react-router-dom";

export default function Game() {


    if (localStorage.getItem("user_code") === null) {
        return (
            <>
            <div className="video-container"><iframe width="560" height="315" src="https://www.youtube.com/embed/7yBPI8aZNPg" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>
            
            <NavLink to="/reg">
            <Button className="is-primray is-fullwidth my-4" color="primary"><strong>Zarejestruj się</strong></Button>
            </NavLink>
    
            <Link to="/log">
            <Button className="is-outlined is-fullwidth"  color="primary"><strong>Zaloguj się</strong></Button>
            </Link>
            </>
            
        );
    }
    else
    {
        return(
        <>
        <Level />
        </>
        );
    }

    
}